import {
  GET_BEST_OFFERS_SUCCEEDED,
  GET_BEST_OFFERS_FAILED,
  GET_BEST_OFFERS,
  USER_UPDATED_BEST_OFFER_STATE,
  USER_RESET_PERSONAL_OPTIONS,
  USER_SELECTED_FINANCE_TAB,
  USER_RESET_TERM_MILEAGE,
  USER_SELECTED_LEASE_TAB,
  INITIAL_DOWN_PAYMENT_LOADED,
  INITIAL_DOWN_PAYMENT_RESET
} from '../constants';
import { getBestOfferOptions } from '../../services';
import { get } from '../../utils';

export function getBestOfferActionFromState() {
  return (dispatch, getState) => {
    const state = getState();
    dispatch({
      type: GET_BEST_OFFERS,
    });
    getBestOfferOptions(state).then((result) => {
      dispatch({
        type: GET_BEST_OFFERS_SUCCEEDED,
        offers: result
      });
      return result;
    })
      .catch((error) => {
        dispatch({
          type: GET_BEST_OFFERS_FAILED,
          error
        });
      });
  }
}

export function updateBestOfferState(id, options, paymentType, optionType) {
  return (dispatch, getState) => {
    const modelLineCode = get(getState(), 'navigation.modelLineCode');
    const nCode = get(getState(), 'navigation.nCode');
    const dmaId = get(getState(), 'dma.dmaId');
    dispatch({
      type: USER_UPDATED_BEST_OFFER_STATE,
      id,
      dmaId,
      modelLineCode,
      nCode,
      options,
      paymentType,
      optionType
    });
  };
}

export function resetTermMileage() {
  return (dispatch) => {
    dispatch({
      type: USER_RESET_TERM_MILEAGE
    });
  }
}

export function restBestOffers() {
  return (dispatch) => {
    dispatch({
      type: USER_RESET_PERSONAL_OPTIONS
    });
  };
}

export function userSelectedFinanceTab() {
  return (dispatch) => {
    dispatch({
      type: USER_SELECTED_FINANCE_TAB
    });
  }
}

export function userSelectedLeaseTab() {
  return (dispatch) => {
    dispatch({
      type: USER_SELECTED_LEASE_TAB
    });
  }
}

export function initialRenderCompleted() {
  return (dispatch) => {
    dispatch({
      type: INITIAL_DOWN_PAYMENT_LOADED
    });
  }
}

export function initialRenderReset() {
  return (dispatch) => {
    dispatch({
      type: INITIAL_DOWN_PAYMENT_RESET
    });
  }
}



/** WEBPACK FOOTER **
 ** ./src/redux/actions/bestOffers.js
 **/